import axios from "axios";
import { message as AntdAlert } from "antd";
import { put, takeLatest } from "redux-saga/effects";
import * as actions from "../actions";
import * as constants from "../constants";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";

export function* handleFetchAutoAssign() {
  try {
    const response = yield axios.get(`${baseURL}/api/v2/admin/auto-badges`);
    if (response.data.success) {
      yield put(actions.fetchAutoAssignSuccess(response.data.data.autoBadges));
    } else {
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchAutoAssignError());
    AntdAlert.error("Something went wrong!");
  }
}

export function* handleFetchAutoAssignTime() {
  try {
    const response = yield axios.get(
      `${baseURL}/api/v2/admin/auto-badges/get-auto-assign-time`
    );

    if (response.data.success) {
      yield put(
        actions.fetchAutoAssignTimeSuccess(response.data.data.auto_assign_time)
      );
    } else {
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchAutoAssignTimeError());
    AntdAlert.error("Something went wrong!");
  }
}

export function* handleUpdateAutoAssign({ data }) {
  const { name, start_range, end_range, badge, auto_badge_id, deleted_status } =
    data;

  try {
    const fd = new FormData();
    fd.append("name", name);
    fd.append("start_range", start_range);
    fd.append("end_range", end_range);
    fd.append("badge", badge);
    fd.append("deleted_status", deleted_status);
    fd.append("auto_badge_id", auto_badge_id);

    const response = yield axios.put(
      `${baseURL}/api/v2/admin/auto-badges/67c96626de12745b2a32389d`,
      fd
    );

    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message);
      yield put(actions.updateAutoAssignSuccess(response.data.data.autoBadge));
    } else {
      AntdAlert.error(message);
      yield put(actions.updateAutoAssignError(response.data.data));
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.updateAutoAssignError(error?.response?.data?.data || {}));
    AntdAlert.error("Something went wrong!");
  }
}

export function* handleCreateAutoAssign({ data }) {
  const { name, badge, deleted_status, start_range, end_range } = data;

  try {
    const fd = new FormData();
    fd.append("name", name);
    fd.append("badge", badge);
    fd.append("deleted_status", deleted_status);
    fd.append("start_range", start_range);
    fd.append("end_range", end_range);

    const response = yield axios.post(
      `${baseURL}/api/v2/admin/auto-badges`,
      fd
    );
    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message);
      yield put(actions.createAutoAssignSuccess(response.data.data.autoBadge));
    } else {
      AntdAlert.error(response.data?.errors?.[0] || "Error occurred");
      yield put(actions.createAutoAssignError(data.id));
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
    yield put(actions.createAutoAssignError());
  }
}

export function* handleUpdateAutoTime({ data }) {
  const { intervalTime, setIsModalVisible, job_initialize_time } = data;

  try {
    const fd = new FormData();
    fd.append("intervalTime", intervalTime);
    fd.append("job_initialize_time", job_initialize_time);
    const response = yield axios.post(
      `${baseURL}/api/v2/admin/auto-badges/update-auto-assign-time`,
      fd
    );
    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message);
      yield put(actions.updateAutoTimeSuccess(response.data));
      setIsModalVisible(false);
    } else {
      AntdAlert.error(response.data?.errors?.[0] || "Error occurred");
      yield put(actions.updateAutoTimeError(data.id));
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
    yield put(actions.updateAutoTimeError());
  }
}

export function* handleUpdateAutoNow({ data }) {
  try {
    const fd = new FormData();
    const response = yield axios.post(
      `${baseURL}/api/v2/admin/auto-badges/update-auto-badges-now`,
      fd
    );
    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message);
      yield put(actions.updateAutoNowSuccess(response.data));
      yield put(actions.fetchAutoAssign());
    } else {
      AntdAlert.error(response.data?.errors?.[0] || "Error occurred");
      yield put(actions.updateAutoNowError(data.id));
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
    yield put(actions.updateAutoNowError());
  }
}

export function* watcherAutoAssignSaga() {
  yield takeLatest(constants.FETCH_AUTO_ASSIGN, handleFetchAutoAssign);
  yield takeLatest(constants.FETCH_AUTO_ASSIGN_TIME, handleFetchAutoAssignTime);
  yield takeLatest(constants.CREATE_AUTO_ASSIGN, handleCreateAutoAssign);
  yield takeLatest(constants.UPDATE_AUTO_ASSIGN, handleUpdateAutoAssign);
  yield takeLatest(constants.UPDATE_AUTO_TIME, handleUpdateAutoTime);
  yield takeLatest(constants.UPDATE_AUTO_NOW, handleUpdateAutoNow);
}
